import { ChannelState } from '@/types/store'
import { ChannelEntity } from '../../../api/@types'
import { MutationTree } from 'vuex'

export const mutations: MutationTree<ChannelState> = {
  setIsChannelLoading(state, isLoading: boolean) {
    state.isChannelLoading = isLoading
  },
  channelLoaded(state, channels: ChannelEntity[]) {
    state.channels = channels
  },
}
